import { useEffect } from "react";
import { formatPhoneNumberIntl, isValidPhoneNumber } from "react-phone-number-input";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { setPhoneNumber } from "../../app/voucherSlice";


const PhoneNumberGetter = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();

    useEffect(() => {
        getPhoneNumberFromQueryString();
    }, [getPhoneNumberFromQueryString])

    function getPhoneNumberFromQueryString() {
        const newPhoneNumber = new URLSearchParams(location.search.toLowerCase()).get('phonenumber') || '';
        if (isValidPhoneNumber(newPhoneNumber))
            dispatch(setPhoneNumber(formatPhoneNumberIntl(newPhoneNumber)));
    }

    //getPhoneNumberFromQueryString();

    return null;
};

export default PhoneNumberGetter;
